import { Modal, Alert, Button } from '@/shared/components/ui';
import { LogOut } from 'lucide-react';
import { useSesionBloqueada } from '../../model/useSesionBloqueada';
import styles from './PantallaSesionCerrada.module.css';

/**
 * PantallaSesionCerrada - Pantalla fullscreen cuando sesión fue cerrada remotamente
 * 
 * Se muestra cuando:
 * - Otra tab del mismo navegador eligió "Usar Aquí y Cerrar Otra"
 * - Otro dispositivo cerró esta sesión
 * 
 * SEGURIDAD: Igual que PantallaBloqueo, usa state persistente en localStorage
 * para prevenir bypass por depuración/refresh
 */
export const PantallaSesionCerrada = () => {
    const { desbloquearSesion } = useSesionBloqueada();

    const handleIrAlLogin = () => {
        // CRÍTICO: Limpiar estado antes de navegar
        desbloquearSesion();

        // Navegar al login
        window.location.href = '/login';
    };

    return (
        <Modal
            isOpen={true}
            onClose={() => { }} // No cerrable
            title="Sesión Cerrada"
            size="md"
            closeOnOverlayClick={false}
        >
            <div className={styles.container}>
                {/* Icono */}
                <div className={styles.iconWrapper}>
                    <LogOut className={styles.icon} size={64} />
                </div>

                {/* Mensaje */}
                <Alert type="error">
                    Tu sesión fue cerrada desde otra pestaña o dispositivo.
                </Alert>

                <p className={styles.description}>
                    Por seguridad, solo puede haber una sesión activa a la vez.
                    <br />
                    <br />
                    Por favor, inicia sesión nuevamente o cierra manualmente esta pestaña.
                </p>

                {/* Acción */}
                <div className={styles.actions}>
                    <Button
                        variant="primary"
                        onClick={handleIrAlLogin}
                        fullWidth
                    >
                        <LogOut size={18} style={{ marginRight: '0.5rem' }} />
                        Ir al Login
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
